import { Box, InputLabel, styled, TextField, Typography } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

export const Label = styled(InputLabel)(
  ({ textcolor, $disabled, theme }) => `
  font-weight: ${textcolor === 'charcoal' ? 200 : 400};
  color: ${$disabled ? theme.palette.brand.disabled : 'inherit'};
`,
);

export const InputTextField = styled(TextField)(
  ({ theme }) => `
    && {
      input {
        font-weight: 300;
        font-size: 1rem;
        line-height: 1.125rem;
        background: ${theme.palette.secondary.lighter};
      }
    }
`,
);

export const InputDate = styled(MobileDatePicker)(
  ({ theme }) => `
  width: 100%;
  .Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.palette.secondary.dark};
  }
  .Mui-error {
    color: ${theme.palette.secondary.dark};
  }
  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.palette.brand.disabled};
  }
  .Mui-disabled .MuiSvgIcon-root {
    color: ${theme.palette.brand.disabled};
  }
`,
);

export const OOContanier = styled(Box)`
  margin-top: 10px;
`;

export const OOTitle = styled(Typography)(
  () => `
  font-size:20px;
  font-weight:400;
  font-family:Roboto;
`,
);

export const OOSubText = styled(Typography)(
  () => `
  font-size:16px;
  font-weight:500;
`,
);

export const CheckBoxContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const Container = styled(Box)`
  padding: 10px;
  width: 850px;
`;
